import { ParameterType } from '@/study-search/enums';
import { FilterKey } from '@studyportals/search-filters/server-side';

import { IIndexation } from '../../../interfaces';
import { SingleValueFilter } from '../SingleValueFilter';

export class KeywordWhatFilter extends SingleValueFilter implements IIndexation {
	public constructor() {
		super(FilterKey.KEYWORD_WHAT, ParameterType.KEYWORD_WHAT, [], false, false);
	}

	public canBeIndexed(): boolean {
		return this.values.length === 1;
	}
}
